export default __webpack_public_path__ + "static/media/Honored Vambraces of the Ancestors.f3109491.jpg";